import { currentTimeZone } from 'infras/datetime';
import { TimeZoneListItem } from 'presentations/api/schema/time_zone';
import { apiPath } from 'presentations/routes/path';
import { useRequest } from 'presentations/views/hooks/request';
import { SyntheticEvent, useMemo, useState } from 'react';

interface Props {
  onSelect: (timeZone: string) => void;
}

export const useTimeZoneList = (props: Props) => {
  const [query, setQuery] = useState<string>('');
  const timeZonesRequest = useRequest(apiPath('/v1/time_zones'));
  const timeZoneItems = (timeZonesRequest.data || []) as TimeZoneListItem[];
  const timeZones = useMemo(() => {
    return timeZoneItems.filter((tz) => {
      const reg = new RegExp(`.*${query}.*`, 'gi');
      const text = [tz.name, tz.offsetNameShort, tz.offsetNameLong].join(' ');
      return !!text.match(reg);
    });
  }, [timeZoneItems, query]);
  const onChangeQuery = (e: SyntheticEvent<HTMLInputElement>, text: string) => {
    const { value } = e.currentTarget;
    setQuery(value);
  };
  const onSelect = (e: SyntheticEvent<HTMLDivElement>) => {
    if (!props.onSelect) return;
    const { id } = e.currentTarget.dataset;
    props.onSelect(timeZones[Number(id)].name);
  };

  const placeholder = useMemo(() => {
    return currentTimeZone().split('/').reverse()[0];
  }, []);
  return {
    state: {
      timeZones,
      isLoading: timeZonesRequest.isLoading,
      query,
      placeholder,
    },
    actions: {
      onSelect,
      onChangeQuery,
    },
  };
};
